import { navigate } from '@reach/router'
import gql from 'graphql-tag'
import * as _ from 'lodash'
import * as React from 'react'
import { useQuery } from 'react-apollo'

import { listproducts, listUserCourses } from '../../graphql/queries'
import { publicClient } from '../../utils/apolloClient'
import { getCurrentUser } from '../../utils/auth'
import Layout from '../layout/SiteLayout'
import { RouteProps } from '../types'

const RoutePrivateLecture = ({
  component: Component,
  location,
  ...rest
}: RouteProps) => {
  const { path, title, description, frontmatter } = rest
  const user = getCurrentUser() || {}
  const { loading, data, error } = useQuery(
    gql`
      ${listproducts}
    `,
    { client: publicClient }
  )
  const products = _.get(data, 'listproducts') || []
  const oneProduct = _.filter(products, o => o.name === frontmatter.title)[0]
  const {
    loading: userCourseLoading,
    data: userCourseData,
    error: userCourseError,
  } = useQuery(
    gql`
      ${listUserCourses}
    `,
    {
      skip: oneProduct === undefined ? true : false,
      variables: {
        filter: {
          owner: { eq: _.get(user, 'email') },
          courseId: { eq: _.get(oneProduct, 'id') },
        },
        limit: 10000,
      },
    }
  )
  const purchases = _.get(userCourseData, 'listUserCourses.items') || []

  const { paid } = frontmatter

  if (paid && !userCourseLoading && !loading) {
    if (purchases.length === 0) {
      navigate(`${oneProduct.metadata.slug}#purchase`)
      return null
    }
  }
  const hasBought = !userCourseLoading && !loading && purchases.length > 0

  return (
    <Layout
      path={path}
      title={title}
      description={description}
      darktheme={false}
    >
      <Component {...rest} hasBought={hasBought} path={path} />
    </Layout>
  )
}

export default RoutePrivateLecture
